export const AgreementNames = {
  MASTER_CLIENT_AGREEMENT: 'MASTER_CLIENT_AGREEMENT',
  MASTER_CLIENT_AGREEMENT_US: 'MASTER_CLIENT_AGREEMENT_US',
  UK_EMI: 'UK_EMI',
  MALTA_EMI: 'MALTA_EMI',
} as const
